import React from 'react';
import { componentFromInput } from '../util';
var Description = function Description(_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    description = _ref.description;
  var DescriptionText = componentFromInput(description);
  return /*#__PURE__*/React.createElement("span", {
    className: styles.description || 'help-block'
  }, /*#__PURE__*/React.createElement(DescriptionText, null));
};
export default Description;